let inject = ['$scope', '$uibModalInstance','modalOptions','CategoryProductsService'];

class ModalAtributosValoresController {
  constructor ($scope,$uibModalInstance,modalOptions,CategoryProductsService) {
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.modalOptions = Object.assign({}, modalOptions);
	this.CategoryProductsService = CategoryProductsService;
  }
  
  $onInit(){
	  //this.attributesFilters = (this.CategoryProductsService.getFiltersData().filters.attributes) ? this.CategoryProductsService.getFiltersData().filters.attributes : { [this.modalOptions.atributoId] : [] };	  
	  this.mostrarBorrar = [];
	  this.newFilters = [];
  }
  
  
  almacenar(group, value, addRemove, att, val,title) {
	  this.newFilters.push({ group, value, addRemove, att, val,title });
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  ok() {
    this.$uibModalInstance.close(this.newFilters);
  }
}

ModalAtributosValoresController.$inject = inject;

export default ModalAtributosValoresController;



// WEBPACK FOOTER //
// ./www/components/catalog/products-list/modal-atributos-valores/modal-atributos-valores.controller.js